import { computed, ComputedRef } from 'vue';
import { computedEager, useMediaQuery } from '@vueuse/core';

/**
 * Composable for handling responsive background images on public pages.
 * Provides breakpoint detection and helper function to select correct image variant.
 */
const usePublicPageBackgrounds = () => {
  const isSmartphone = useMediaQuery('(width < 800px)');
  const isTablet = useMediaQuery('(800px <= width < 1020px)');

  const backgroundNr = computedEager(() => {
    if (isSmartphone.value) return 2;
    if (isTablet.value) return 1;
    return 0;
  });

  /**
   * Returns a computed ref that selects the correct image from an array
   * based on the current screen size.
   * @param images Array of [desktop, tablet, smartphone] image paths
   * @returns Computed ref to the appropriate image
   */
  const getResponsiveImage = (images: [string, string, string]): ComputedRef<string> => computed(() => images[backgroundNr.value]);

  return {
    backgroundNr,
    isSmartphone,
    isTablet,
    getResponsiveImage
  };
};

export default usePublicPageBackgrounds;
